import React from 'react';
import PropTypes from 'prop-types';
import { ProductSlideContent } from '../ProductSlideContent';
import { ProductSlideContentV2 } from '../ProductSlideContentV2';

const PRODUCT_SLIDE_VARIANTS = {
    v1: ProductSlideContent,
    v2: ProductSlideContentV2
};

function ProductSlide({ variant = 'v1', ...contentProps }) {
    const Content = PRODUCT_SLIDE_VARIANTS[variant] || ProductSlideContent;

    return <Content {...contentProps} />;
}

ProductSlide.propTypes = {
    variant: PropTypes.oneOf(Object.keys(PRODUCT_SLIDE_VARIANTS))
};

export {
    ProductSlide
};
